import { AddToHumanReviewButton } from "@/human-feedback/projects"
import { AddMetricsToRunButton, type RerunMetricsById } from "@/metrics/rerun"
import { Button } from "@coval/ui"
import { Database, Trash2 } from "lucide-react"

import { ResimulateButton } from "../action-buttons/ResimulateButton"

interface RunResultsBulkActionsProps {
  cancelledSelectionDisabledReason?: string
  isGeneratingTestSet: boolean
  isShared?: boolean
  metricIdFilter: string | null
  onBulkDelete: () => void
  onGenerateTestSet: () => void
  onRerunSuccess: () => void
  rerunMetricRecordsById?: RerunMetricsById | null
  rerunMetricsCount: number
  rerunMetricsLabel?: string
  runId?: string
  selectableSimulationOutputIds: string[]
  selectedSimulationOutputIds: string[]
  selectedTestCaseIds: string[]
  /**
   * False where the table's run-level actions declare that their overflow menu
   * hosts the delete for the selection, so this bar doesn't repeat it.
   */
  showDeleteAction: boolean
}

/** The actions that act on the rows a reviewer has selected in the results table. */
export const RunResultsBulkActions = ({
  cancelledSelectionDisabledReason,
  isGeneratingTestSet,
  isShared,
  metricIdFilter,
  onBulkDelete,
  onGenerateTestSet,
  onRerunSuccess,
  rerunMetricRecordsById,
  rerunMetricsCount,
  rerunMetricsLabel,
  runId,
  selectableSimulationOutputIds,
  selectedSimulationOutputIds,
  selectedTestCaseIds,
  showDeleteAction,
}: RunResultsBulkActionsProps) => (
  <div className="flex items-center gap-2 flex-wrap">
    <ResimulateButton
      simulationOutputIds={selectedSimulationOutputIds}
      isShared={isShared}
      runId={runId}
      testCaseIds={selectedTestCaseIds}
    />
    {rerunMetricRecordsById && rerunMetricsCount > 0 && (
      <AddMetricsToRunButton
        metricRecordsById={rerunMetricRecordsById}
        simulationOutputIds={selectableSimulationOutputIds}
        selectedSimulationOutputIds={selectedSimulationOutputIds}
        forcedMetricIds={metricIdFilter ? [metricIdFilter] : undefined}
        buttonLabelOverride={rerunMetricsLabel}
        disabled={Boolean(cancelledSelectionDisabledReason)}
        title={cancelledSelectionDisabledReason}
        onSuccess={onRerunSuccess}
      />
    )}
    <AddToHumanReviewButton simulationOutputIds={selectedSimulationOutputIds} />
    <Button
      variant="secondary"
      onClick={onGenerateTestSet}
      loading={isGeneratingTestSet}
    >
      <Database />
      Generate Test Set
    </Button>
    {showDeleteAction && (
      <Button icon variant="danger" tooltip="Delete" onClick={onBulkDelete}>
        <Trash2 />
      </Button>
    )}
  </div>
)
